import { BaseService } from '../../../infra/base.service'
import type { ProductOpenUnit } from './product-open-unit'
import type { ProductConsumptionRepository } from './product-consumption.repository'

export class ProductConsumptionService extends BaseService<ProductOpenUnit> {
    constructor(private rep: ProductConsumptionRepository) {
        super(rep)
    }

    async closeUnit(productOpenUnitId: string) {
        return await this.rep.closeUnit(productOpenUnitId)
    }

    async reopenUnit(productOpenUnitId: string) {
        return await this.rep.reopenUnit(productOpenUnitId)
    }

    async voidOpening(productOpenUnitId: string) {
        return await this.rep.voidOpening(productOpenUnitId)
    }

    async estimateRemaining(productOpenUnitId: string) {
        return await this.rep.estimateRemaining(productOpenUnitId)
    }

    async findLogs(params?: { serviceId?: string; appointmentId?: string; from?: Date; to?: Date }) {
        return await this.rep.findLogs(params)
    }

    async sumLoggedForUnits(productOpenUnitIds: string[]) {
        return await this.rep.sumLoggedForUnits(productOpenUnitIds)
    }
}
